/**
 * validate
 * A whole-record validation function that takes all the values of the form and returns any validation errors.
 * {@link https://final-form.org/docs/final-form/types/Config#validate}
 */

// Form
import {
    validators
    // @ts-ignore
} from 'forms';

// Utils
import { calculateTotalPaidMinutes } from 'utils/timesheets';

// Types
import { TimesheetErrors, TimesheetEntryErrors } from './types';

// Validators
const { isRequired } = validators;

const validateTimesheet = (values: any): TimesheetErrors => {
    const errors: TimesheetErrors = {};
    const { entityId } = values;

    errors.entityId = isRequired(entityId);

    return errors;
};

const validateTimesheetEntry = (values: any): TimesheetEntryErrors => {
    const errors: TimesheetEntryErrors = {};

    const {
        startTime,
        endTime,
        unpaidBreakMinutes = 0,
        paidBreakMinutes = 0
    } = values;

    const totalPaidHours = calculateTotalPaidMinutes({
        startTime,
        endTime,
        unpaidBreakMinutes
    });

    const totalHours = totalPaidHours - paidBreakMinutes;

    if (totalHours <= 0) {
        errors.endTime =
            'End time must be more than the total breaks after the start time';
    }
    return errors;
};

export { validateTimesheet, validateTimesheetEntry };
